import {call, put, takeEvery} from 'redux-saga/effects';
import {logError} from '@yandex-int/pythia-libs';

import {SurveyState} from 'client/common/store/reducers/survey/types';
import {updateSurveyListItem} from 'client/common/store/reducers/surveys';
import {showNotification} from 'client/common/store/actions/notifications';
import {
    resumeQuicksurvey,
    cancelQuicksurveyModeration,
    pauseQuicksurvey
} from 'client/common/store/actions/quicksurvey';

import {updateSurvey} from 'client/common/utils/api-client/constructor';
import I18N from 'assets/i18n/brandlift-project';

import {ApiResponse} from 'client/common/store/saga/types';

const i18n = I18N.common.saga.quicksurvey.survey;

export function* updateState(slug: string, state: SurveyState) {
    try {
        const res: ApiResponse<typeof updateSurvey> = yield call(updateSurvey, {
            slug,
            state
        });

        if (res.status === 204) {
            yield call(handleUpdateStateSuccess, slug, state);
        } else {
            yield call(handleUpdateStateFailure, res.data);
        }
    } catch (error) {
        yield call(logError, {message: 'Unexpected error while updating state', err: error});
    }
}

export function* handleUpdateStateSuccess(slug: string, state: SurveyState) {
    yield put(
        updateSurveyListItem({
            slug,
            fields: {state}
        })
    );
}

export function* handleUpdateStateFailure(data: unknown) {
    yield call(logError, {message: 'Error while updating state', additional: {data}});

    yield put(
        showNotification({
            type: 'error',
            timeOut: 5000,
            message: i18n.message.stateNotChanged
        })
    );
}

export function* pauseSurvey(action: ReturnType<typeof pauseQuicksurvey>) {
    const {
        payload: {slug}
    } = action;

    yield call(updateState, slug, SurveyState.Paused);
}

export function* resumeSurvey(action: ReturnType<typeof resumeQuicksurvey>) {
    const {
        payload: {slug}
    } = action;

    yield call(updateState, slug, SurveyState.Active);
}

export function* cancelSurveyModeration(action: ReturnType<typeof cancelQuicksurveyModeration>) {
    const {
        payload: {slug}
    } = action;

    yield call(updateState, slug, SurveyState.Draft);
}

export default function* router() {
    yield takeEvery(pauseQuicksurvey, pauseSurvey);
    yield takeEvery(resumeQuicksurvey, resumeSurvey);
    yield takeEvery(cancelQuicksurveyModeration, cancelSurveyModeration);
}
